import {
  buildScoutPrivateDocumentExtractionWatchPartUrl,
  isScoutPrivateDocumentExtractionWatchPartUrl,
  SCOUT_PRIVATE_DOCUMENT_EXTRACTION_WATCH_URL_PREFIX,
} from "encamp-constants/scout";

export {
  buildScoutPrivateDocumentExtractionWatchPartUrl,
  isScoutPrivateDocumentExtractionWatchPartUrl,
  SCOUT_PRIVATE_DOCUMENT_EXTRACTION_WATCH_URL_PREFIX,
};

const SCOUT_EXTRACTION_WATCH_MARKER_PATTERN = /\[scout-extraction-watch:([0-9a-f-]{36})\]/gi;

export function formatScoutExtractionWatchUserMessage(privateDocumentIds: string[]): string {
  if (privateDocumentIds.length === 1) {
    return `Start the full analysis.\n[scout-extraction-watch:${privateDocumentIds[0]}]`;
  }

  const markers = privateDocumentIds.map(
    (privateDocumentId) => `[scout-extraction-watch:${privateDocumentId}]`
  );
  return `Start full analysis on all attached documents.\n${markers.join("\n")}`;
}

export function parseScoutExtractionWatchDocumentIdFromText(
  text: string | null | undefined
): string | undefined {
  return parseScoutExtractionWatchDocumentIdsFromText(text)[0];
}

export function parseScoutExtractionWatchDocumentIdsFromText(
  text: string | null | undefined
): string[] {
  if (!text) {
    return [];
  }

  const matches = [...text.matchAll(/\[scout-extraction-watch:([0-9a-f-]{36})\]/gi)];
  return matches.map((match) => match[1]).filter((value): value is string => value !== undefined);
}

export function stripScoutExtractionWatchMarkerFromText(text: string): string {
  return text.replace(SCOUT_EXTRACTION_WATCH_MARKER_PATTERN, "").trim();
}
